module.exports = __webpack_public_path__ + "img/Banner_01_Arreglalo_Febrero_desk.7930698e.jpg";